import type { GameMeta } from '@gmp/game-sdk';

/** Catalog data only (no rules or content), so menus can show the game without loading it. */
export const initialReactionMeta = {
  id: 'initial-reaction',
  name: 'Initial Reaction',
  tagline: 'Three letters. One category. Make up what they stand for.',
  description:
    'Everyone gets the same acronym and a category ("a boy band", "a law nobody follows"). Write what it stands for, one word per letter, then vote for the best answer anonymously. Some rounds the acronym is real: write a fake so convincing the table picks it. The final round spells out the leader\'s name.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [10, 20],
  usesMedia: false,
  modes: [{ id: 'classic', name: 'Classic', description: 'Acronyms that grow from 3 to 5 letters, Real or Fake rounds and a Name Drop finale.' }],
  theme: { primary: '#d6402b', secondary: '#f2b134', background: '#17130f', ink: '#f3ead7' },
  readiness: 'beta',
  genre: 'Comedy writing and voting',
  controls: 'tap',
  category: 'party',
  instructions: [
    { icon: 'Type', title: 'Get your letters', body: 'Everyone gets the same acronym and a category. One word per letter, in order. Little words like "of", "and" and "the" may sit in between.' },
    { icon: 'PenLine', title: 'Write it', body: 'Type what it stands for. The letter tiles light up as your words fit. The fastest valid answer earns a bonus if anyone votes for it.' },
    { icon: 'Vote', title: 'Vote', body: 'Answers appear anonymously. Vote for your favourite (never your own) and, if you like, groan at the worst one.' },
    { icon: 'VenetianMask', title: 'Real or Fake', body: 'Some acronyms are real. Write a convincing fake, then find the real meaning: +200 for spotting it, +100 for every player your fake fools.' },
    { icon: 'Trophy', title: 'Name Drop', body: 'The final round spells the leader\'s name. Votes count double.' },
  ],
} satisfies GameMeta;
